import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "components/shared/toast/toast";
import { ANNOUNCEMENT } from "services/apiEndpoints";
import { privateDelete, privateGet } from "services/privateRequest";
import { makeQueryString } from "utils/utils";

const initialState = {
  announcements: [],
  isFetching: false,
  filterValues: {},
  announcementsSent: {
    totalCount: 0,
    pageNumber: 1,
    limit: 10,
    status: "idle", // 'idle' | 'loading' | 'error'
  },
  announcementsSchedule: {
    totalCount: 0,
    pageNumber: 1,
    limit: 10,
    status: "idle", // 'idle' | 'loading' | 'error'
  },
  selectedAnnouncementId: {},
};


export const deleteAnnouncement = createAsyncThunk(
  "announcement/deleteAnnouncement",
  async (id, { dispatch }) => {
    await privateDelete(ANNOUNCEMENT, id);
    // dispatch(getAnnouncementData());
    toast.success("Projects deleted successfully");
  }
);


export const fetchannouncementList = createAsyncThunk(
  "announcement/fetchannouncementList",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const queryString = makeQueryString(ANNOUNCEMENT, payload);
      const response = await privateGet(queryString);
      if (payload?.notificationType === "sent") {
        dispatch(
          setAnnpuncementsSentPagination({
            pageNumber: payload.pageNumber,
            limit: payload.limit,
            totalCount: response.data.data?.totalCount
          })
        );
      } else {
        dispatch(
          setAnnpuncementsSchedulePagination({
            pageNumber: payload.pageNumber,
            limit: payload.limit,
            totalCount: response.data.data?.totalCount
          })
        );
      }
      return response.data.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      rejectWithValue(error);
    }
  }
);



const announcementSlice = createSlice({
  name: "announcements",
  initialState,
  reducers: {
    setIsFetching: (state, action) => {
      state.isFetching = action.payload;
    },
    setFilterValues: (state, action) => {
      state.filterValues = action.payload;
    },
    clearAnnouncements: (state) => {
      state.announcements = [];
    },
    setAnnpuncementsSentPagination: (state, action) => {
      state.announcementsSent.pageNumber = action.payload.pageNumber;
      state.announcementsSent.limit = action.payload.limit
      state.announcementsSent.totalCount = action.payload.totalCount
    },
    setAnnpuncementsSchedulePagination: (state, action) => {
      state.announcementsSchedule.pageNumber = action.payload.pageNumber;
      state.announcementsSchedule.limit = action.payload.limit;
      state.announcementsSchedule.totalCount = action.payload.totalCount

    },
    setSelectedAnnouncementId: (state, action) => {
      state.selectedAnnouncementId = action.payload
    }
  },
  extraReducers: {
    [fetchannouncementList.pending]: (state, action) => {
      if (action.meta.arg?.notificationType === "sent") {
        state.announcementsSent.status = "loading";
      } else {
        state.announcementsSchedule.status = "loading";
      }
    },
    [fetchannouncementList.fulfilled]: (state, action) => {
      if (action.meta.arg?.notificationType === "sent") {
        state.announcementsSent.status = "idle";
      } else {
        state.announcementsSchedule.status = "fetched";
      }
      const transFormData = action?.payload?.result?.map(ele => ({
        ...ele,
        openedCount: ele.recipientsStatus.filter(item => item.status === "opened").length
      }))
      state.announcements = transFormData || [];
    },
    [fetchannouncementList.rejected]: (state) => {
      state.announcementsSent.status = "error";
    },
  },
});

export default announcementSlice.reducer;
export const {
  setIsFetching,
  setFilterValues,
  setAnnpuncementsSentPagination,
  setAnnpuncementsSchedulePagination,
  clearAnnouncements
} = announcementSlice.actions;
